import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Thead, Th, Tr, Td } from 'components/reactable';
import styles from './clientClaims.scss';
import ClaimZoom from './clientClaimsZoom';
import {
  fetchClientClaims,
  setOpenedSubmenu,
  fetchClaimsExtraDetails,
  getClaimDetail,
} from 'state/actions';
import { dateFormatter } from 'lib/helpers';
import nesProp from 'nested-property';
import i18n from 'lib/i18n';

const _ = i18n('clientClaims');

const formatQualification = (main) => (
  <span>
    <span>{main.qualification}</span>
    {main.subQualification && (
      <span>
        ,<br />
        {main.subQualification}
      </span>
    )}
  </span>
);

const Results = ({ claims, zoomTo }) => {
  const moment = require('moment');
  const formattedData = claims.map(({ claimMain, claimDetails }) => ({
    ...claimMain,
    claimDate: moment(claimMain.claimDate).format('DD-MM-YYYY'),
    creationDate: moment(claimMain.creationDate).format('DD-MM-YYYY'),
    insuranceCompany: claimDetails.insuranceCompany || '',
  }));

  return (
    <div className={styles.clientsTableContainer}>
      <Table
        className={styles.table}
        itemsPerPage={10}
        filterable={[
          'claimDate',
          'creationDate',
          'claimNumber',
          'contractNumber',
          'insuranceCompany',
          'claimsManager',
          'qualification',
          'state',
        ]}
        sortable={[
          { column: 'claimDate', sortFunction: 'Date' },
          { column: 'creationDate', sortFunction: 'Date' },
          'claimNumber',
          'contractNumber',
          'insuranceCompany',
          'claimsManager',
          'qualification',
          'state',
        ]}
        defaultSort={{
          column: 'creationDate',
          direction: 'desc',
        }}
      >
        <Thead>
          <Th column="claimDate"><strong>{_('claimDate')}</strong></Th>
          <Th column="creationDate"><strong>{_('creationDate')}</strong></Th>
          <Th column="claimNumber"><strong>{_('claimNumber')}</strong></Th>
          <Th column="contractNumber"><strong>{_('contractNumber')}</strong></Th>
          <Th column="insuranceCompany"><strong>{_('insuranceCompany')}</strong></Th>
          <Th column="claimsManager"><strong>{_('claimsManager')}</strong></Th>
          <Th column="qualification"><strong>{_('qualification')}</strong></Th>
          <Th column="state"><strong>{_('status')}</strong></Th>
        </Thead>
        {formattedData.map((item, key) => (
          <Tr className="centered clickable" onClick={() => zoomTo(item.claimId)} key={key}>
            <Td column="claimDate" data={dateFormatter(item.claimDate)} />
            <Td column="creationDate" data={dateFormatter(item.creationDate)} />
            <Td column="claimNumber">{item.claimNumber}</Td>
            <Td column="contractNumber">{item.contractNumber}</Td>
            <Td column="insuranceCompany">{item.insuranceCompany}</Td>
            <Td column="claimsManager">{item.claimsManager}</Td>
            <Td column="qualification" data={formatQualification(item)} value={`${item.qualification} ${item.subQualification}`} />
            <Td column="state">{item.state}</Td>
          </Tr>
        ))}
      </Table>
    </div>
  );
};

@connect(({ app, clients, claimsExtraDetails }, props) => {
  const clientId = app.opened;
  const claimId = app.submenuOpened;
  const claims = clients.claims[clientId];
  const clientData = props.clientData && props.clientData || {};
  return {
    clientId,
    claims,
    claimId,
    clientData,
    claimsExtraDetails: clients.claimsExtraDetails,
    subModuleZoom: clients.subModuleZoom,
  };
})
export default class ClientClaims extends Component {
  static propTypes = {
    claims: PropTypes.array,
    clientId: PropTypes.string.isRequired,
    claimId: PropTypes.string,
    clientData: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      initializationCompleted: false,
      claimSearchResult: {},
    };
  }

  async componentDidMount() {
    const { clientData, dispatch, claimId, clientId, claims, subModuleZoom } = this.props;
    const clientNumber = nesProp.get(clientData, 'main.clientNumber');

    try {
      const fetches = [];

      if (!claims || claims.length === 0) {
        fetches.push(dispatch(fetchClientClaims(clientId)));
        if (clientNumber) {
          fetches.push(dispatch(fetchClaimsExtraDetails({ clientNumber })));
        }
      }

      if (claimId) {
        fetches.push(dispatch(getClaimDetail(claimId)));
      }

      await Promise.all(fetches);
    } catch (e) {
      console.warn('Error fetching claims:', e);
    } finally {
      this.setState({ initializationCompleted: true });
    }
  }

  async componentDidUpdate(prevProps) {
    const { clientId, claimId, claimsExtraDetails, subModuleZoom, dispatch } = this.props;

    if (clientId !== prevProps.clientId || (!claimId && prevProps.claimId)) {
      await dispatch(fetchClientClaims(clientId));
    }

    if (
      claimsExtraDetails !== prevProps.claimsExtraDetails &&
      subModuleZoom &&
      Object.keys(subModuleZoom).length > 0
    ) {
      this.updateClaimSearchResult();
    }
  }

  zoomTo = async (subMenu) => {
    const { dispatch } = this.props;
    await dispatch(getClaimDetail(subMenu));
    this.setState({ claimSearchResult: {} }, () => {
      dispatch(setOpenedSubmenu(subMenu));
    });
  };

  updateClaimSearchResult = async () => {
    const claimSearchResult = await this.getTheSelectedClaimFromSearchResult();
    this.setState({ claimSearchResult });
  };

  getTheSelectedClaimFromSearchResult = async () => {
    const { claimId, claimsExtraDetails, subModuleZoom, dispatch } = this.props;
    if (!Array.isArray(claimsExtraDetails) || claimsExtraDetails.length === 0) {
      return {};
    }

    let result = [];

    if (claimId) {
      result = claimsExtraDetails.filter(
        (currentClaim) => String(currentClaim.main.claimId) === String(claimId)
      );
    }

    if (result.length === 0 && subModuleZoom) {
      result = claimsExtraDetails.filter((currentClaim) =>
        Object.keys(subModuleZoom).some((key) =>
          (key === 'claimNumber' &&
            String(currentClaim.main.claimNumber) === String(subModuleZoom[key])) ||
          (key === 'claimRefBroker' &&
            String(currentClaim.main.claimRefBroker) === String(subModuleZoom[key]))
        )
      );
    }

    if (result.length > 0) {
      await dispatch(getClaimDetail(result[0].main.claimId));
      this.zoomTo(result[0].main.claimId);
      return result[0];
    } else {
      return {};
    }
  };

  render() {
    const { claims, claimId, clientData, clientId, subModuleZoom } = this.props;
    const { initializationCompleted, claimSearchResult } = this.state;

    if (!initializationCompleted) {
      return <span></span>;
    }

    let claim = claimId && claims && claims.find((i) => i.claimMain.claimId === claimId);

    if (!claim && subModuleZoom) {
      const key = Object.keys(subModuleZoom)[0];
      if (key) {
        const value = subModuleZoom[key];
        claim = claims && claims.find((c) => c.claimMain[key] === value);
      }
    }

    return (
      <div className={styles.claimsClient}>
        <div className={styles.moduleSection}>
          {claims && !claimId && Object.keys(claimSearchResult).length === 0 && (
            <Results claims={claims} zoomTo={this.zoomTo} />
          )}
          {(claimId || Object.keys(claimSearchResult).length > 0) && (
            <div className={styles.clientClaimZoomContainer}>
              <ClaimZoom
                claim={claim || {
                  claimDetails: claimSearchResult.details,
                  claimDocuments: claimSearchResult.documents,
                  claimMain: claimSearchResult.main,
                  connex: claimSearchResult.connex,
                }}
                clientData={clientData}
                clientId={clientId}
                claimMoreDetails={claimSearchResult}
                initializationCompleted={initializationCompleted}
                zoomTo={(id) => this.zoomTo(id)}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/clients/clientClaims.jsx